import './overlay-gallery.scss';
/**
 * Module is Functional from ScreenWidth 600Pixel
 [data-gallery] = 'single' or 'slider' / 'multi' -> Not necessary if single image but required if slider. Place on a parent element of images
 [data-gallery-image] for clickable object to to show inside overlay. Place on same tag with data-overlay-src
 [data-gallery-video] for clickable video to to show inside overlay. Place on IMG-Tag
 [data-overlay-src] = Image source (on same element with "data-gallery-image")
 *
 */

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Swiper from 'swiper'; //eslint-disable-line
import { Pagination, Navigation, EffectFade } from 'swiper/modules';
require('../../assets/images/airbubbles.png');

class OverlayGallery {
    constructor (element) {
        this.overlay = null;
        this.$root = element;
        this.videos = [].slice.call(this.$root.querySelectorAll('[data-gallery-video-id]'));
        this.images = [].slice.call(this.$root.querySelectorAll('[data-gallery-image]'));
        this.$overlaySlider = null;
        this.minScreenWidth = 320;
        this.activeIndex = 0;
        this.imageSrcAttr = 'data-overlay-src';
        this.imageArr = [];
        this.slideTypes = [];
        this.$clickedElement = null;
        this.lastOffset = 0;
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.videos.forEach((video) => {
            video.addEventListener('click', (e) => {
                if (window.innerWidth >= this.minScreenWidth && this.overlay === null) {
                    let $wrapper = video.closest('[data-gallery]');
                    let type = 'single';
                    let $nav = [];

                    if ($wrapper) {
                        type = $wrapper.getAttribute('data-gallery');
                        $nav = this.getSliderNav($wrapper);
                    } else {
                        $wrapper = video.parentNode;
                    }

                    this.generateHTML();

                    this.setVideos(type, $wrapper, () => {
                        const position = this.getObjectPosition(e);
                        const $videos = [].slice.call(this.overlay.querySelectorAll('iframe'));

                        document.body.appendChild(this.overlay);
                        const $wrapper = this.overlay.querySelector('.overlay-gallery__wrapper');
                        $wrapper.style.transform = 'translateX(' + position.x + ') translateY(' + position.y + ') scale(0)';

                        if ($videos.length > 1) {
                            this.setSlider(this.overlay.querySelector('[data-overlay-slider]'), $nav);
                        }

                        setTimeout(() => {
                            this.overlay.classList.add('is--visible');
                        }, 50);

                        setTimeout(() => {
                            this.overlay.classList.add('move--in');
                        }, 1);

                        this.setCloseEvent();
                    });
                    this.lastOffset = window.scrollY;
                    disableBodyScroll(document.querySelector('.overlay-gallery'));
                }
            });
        });

        this.images.forEach((element) => {
            element.addEventListener('click', (e) => {
                this.$clickedElement = e;

                if (window.innerWidth >= this.minScreenWidth && this.overlay === null) {
                    let $wrapper = element.closest('[data-gallery]');
                    let type = 'single';
                    let $nav = [];

                    if ($wrapper) {
                        type = $wrapper.getAttribute('data-gallery');
                        $nav = this.getSliderNav($wrapper);
                    } else {
                        $wrapper = element.parentNode;
                    }

                    this.generateHTML();
                    this.setImages(type, element, $wrapper, () => {
                        const $images = [].slice.call(this.overlay.querySelectorAll('img'));
                        const position = this.getObjectPosition(e);

                        document.body.appendChild(this.overlay);
                        const $wrapper = this.overlay.querySelector('.overlay-gallery__wrapper');
                        $wrapper.style.transform = 'translateX(' + position.x + ') translateY(' + position.y + ') scale(0)';

                        if ($images.length > 1) {
                            if (this.$clickedElement.target.getAttribute('data-gallery-image')) {
                                this.activeIndex = parseInt(this.$clickedElement.target.getAttribute('data-gallery-image'));
                            }
                            this.setSlider(this.overlay.querySelector('[data-overlay-slider]'), $nav);
                        }

                        setTimeout(() => {
                            this.overlay.classList.add('is--visible');
                        }, 50);

                        setTimeout(() => {
                            this.overlay.classList.add('move--in');
                        }, 1);

                        this.setCloseEvent();
                    });

                    this.lastOffset = window.scrollY;
                    disableBodyScroll(document.querySelector('.overlay-gallery'));
                }
            });
        });
    }

    getObjectPosition (element) {
        let posX;
        let posY;

        if (element.clientX > (window.innerWidth / 2)) {
            posX = '+' + (element.clientX - (window.innerWidth / 2)) + 'px';
        } else {
            posX = '-' + ((window.innerWidth / 2) - element.clientX) + 'px';
        }
        if (element.clientY > (window.innerHeight / 2)) {
            posY = '+' + (element.clientY - (window.innerHeight / 2)) + 'px';
        } else {
            posY = '-' + ((window.innerHeight / 2) - element.clientY) + 'px';
        }

        return {
            x: posX,
            y: posY
        };
    }

    setSlider ($slider, $nav) {
        let $prev = null;
        let $next = null;

        if ($nav.length > 0) {
            $nav.forEach((nav) => {
                if (nav.getAttribute('class').indexOf('prev') !== -1) {
                    $prev = nav;
                }
                if (nav.getAttribute('class').indexOf('next') !== -1) {
                    $next = nav;
                }
            });
        }

        const imagesArray = this.imageArr;
        const typesArray = this.slideTypes;
        this.$overlaySlider = new Swiper($slider, {
            modules: [Pagination, Navigation, EffectFade],
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            centeredSlides: false,
            threshold: 10,
            init: false,
            autoHeight: true,
            pagination: {
                type: 'bullets',
                clickable: true,
                bulletClass: 'overlay-gallery__bullet',
                bulletActiveClass: 'is--active',
                el: $slider.parentNode.querySelector('.overlay-gallery__pagination'),
                renderBullet: function (index, className) {
                    return '<figure class="' + className + typesArray[index] + '" data-gallery-pagination-index="' + index + '"><img src="' + imagesArray[index] + '" alt=""></figure>';
                }
            },
            initialSlide: this.activeIndex,
            navigation: {
                nextEl: $slider.parentNode.querySelector('.overlay-gallery__next'),
                prevEl: $slider.parentNode.querySelector('.overlay-gallery__prev')
            }
        });

        this.$overlaySlider.on('init', () => {
            const $sliderContainer = this.overlay.querySelector('[data-overlay-slider]');
            setTimeout(() => {
                $sliderContainer.classList.add('has--overflow-visible');
            }, 1000);
        });

        this.$overlaySlider.init();

        setTimeout(() => {
            this.$overlaySlider.on('slideNextTransitionStart', () => {
                if ($next) {
                    $next.click();
                }
            });

            this.$overlaySlider.on('slidePrevTransitionStart', () => {
                if ($prev) {
                    $prev.click();
                }
            });
        }, 500);
    }

    destroySlider () {
        if (this.$overlaySlider !== null) {
            this.$overlaySlider.destroy(true, true);
            this.$overlaySlider.style = '';
            this.activeIndex = 0;
        }
    }

    setCloseEvent () {
        this.overlay.querySelector('[data-overlay-close]').addEventListener('click', () => {
            enableBodyScroll(document.querySelector('.overlay-gallery'));
            window.scroll(0, this.lastOffset);

            this.overlay.classList.remove('is--visible');
            setTimeout(() => {
                this.overlay.remove();
                this.overlay = null;
            }, 1000);
        });
    }

    getSliderNav ($wrapper) {
        return [].slice.call($wrapper.querySelectorAll('[role="button"]'));
    }

    generateHTML () {
        this.overlay = document.createElement('section');
        this.overlay.classList.add('overlay-gallery');

        let template = '<div class="overlay-gallery__wrapper"><div class="overlay-gallery__box"><div class="overlay-gallery__container" data-overlay-slider><div class="swiper-wrapper" data-overlay-images></div>';
        template += '</div>';
        template += '<div class="overlay-gallery__next circle-button circle-button--secondary"><svg aria-hidden="true" role="none" width="24" height="24" class="icon"><use xlink:href="#arrow_right"></use></svg></div>';
        template += '<div class="overlay-gallery__prev circle-button circle-button--secondary"><svg aria-hidden="true" role="none" width="24" height="24" class="icon"><use xlink:href="#arrow_left"></use></svg></div>';
        template += '<div class="overlay-gallery__pagination"></div>';
        template += '<span class="overlay-gallery__close circle-button circle-button--secondary" data-overlay-close><svg aria-hidden="true" role="none" width="24" height="24" class="icon"><use xlink:href="#close"></use></svg></span></div></div></div>';

        this.overlay.innerHTML = template;
    }

    setImages (type, element, $wrapper, callback) {
        let $image = null;
        let $images = null;
        const $imagesTarget = this.overlay.querySelector('[data-overlay-images]');
        let imageTemplate = '';
        let imgUrl = '';

        if (type === 'single') {
            $image = element;
            let $imageSource = null;
            imgUrl = $image.getAttribute(this.imageSrcAttr);

            if (imgUrl === null) {
                $imageSource = $wrapper.querySelector('[' + this.imageSrcAttr + ']');
                if ($imageSource) {
                    imgUrl = $imageSource.getAttribute(this.imageSrcAttr);
                } else {
                    imgUrl = $wrapper.querySelector('img').src;
                }
            }

            const container = document.createElement('div');

            imageTemplate += '<img src="' + imgUrl + '" alt="overlay image">';

            this.overlay.classList.add('is--single');
            container.classList.add('overlay-gallery__image');
            container.innerHTML = imageTemplate;

            $imagesTarget.appendChild(container);
        }

        if (type === 'slider' || type === 'multi') {
            $images = [].slice.call($wrapper.querySelectorAll('[data-gallery-image]'));

            $images.forEach((image, index) => {
                const container = document.createElement('div');
                let $imageSource = null;
                const isVideo = image.getAttribute('data-youtube');

                imgUrl = image.getAttribute(this.imageSrcAttr);

                if (imgUrl === null) {
                    $imageSource = $wrapper.querySelector('[' + this.imageSrcAttr + ']');
                    if ($imageSource) {
                        imgUrl = $imageSource.getAttribute(this.imageSrcAttr);
                    } else {
                        imgUrl = $wrapper.querySelector('img').src;
                    }
                }

                if (imgUrl === '' && isVideo) {
                    imgUrl = '//img.youtube.com/vi/' + isVideo + '/maxresdefault.jpg';
                }

                if (isVideo) {
                    this.slideTypes.push(' is--video');
                } else {
                    this.slideTypes.push(' is--image');
                }

                this.imageArr.push(imgUrl);

                if (image.closest('.swiper-slide-active')) {
                    this.activeIndex = index;
                } else {
                    if (image.closest('.image__images-item') === this.$clickedElement.target.closest('.image__images-item')) {
                        this.activeIndex = index;
                    }
                }

                imageTemplate = '<img src="' + imgUrl + '" alt=""></div>';

                this.overlay.classList.add('is--slider');
                container.classList.add('overlay-gallery__image');
                container.classList.add('swiper-slide');
                container.innerHTML = imageTemplate;
                if (isVideo) {
                    container.classList.add('is--video');
                    const $videoButton = '<a role="button" class="media__play-desktop-default overlay__start-video" data-youtube="' + isVideo + '" data-gallery-video-id="' + isVideo + '" aria-label="Video abspielen">Play</a>';
                    container.innerHTML = imageTemplate + $videoButton;
                }

                $imagesTarget.appendChild(container);
            });

            const $videosStartOnClick = this.overlay.querySelectorAll('.overlay__start-video');
            $videosStartOnClick.forEach((video, index) => {
                video.addEventListener('click', () => {
                    const videoId = video.getAttribute('data-youtube');
                    const $galleryItem = video.parentNode;
                    $galleryItem.classList.add('is--video-shown');

                    import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                        new YoutubePlayer(video, { //eslint-disable-line
                            silent: false,
                            fullscreen: false,
                            controls: true,
                            loop: false,
                            id: videoId,
                            observe: false,
                            gallery: true,
                            onCall: () => {
                                $galleryItem.classList.add('is--video-shown');
                            },
                            onStart: () => {
                                $galleryItem.classList.add('is--video-shown');
                            },
                            onEnd: () => {
                            },
                            onPause: () => {
                                console.log('video pause');
                            }
                        });
                    });
                });
            });
        }

        if (typeof callback === 'function') {
            callback();
        }
    }

    setVideos (type, $wrapper, callback) {
        let $videos = null;
        const videoIdAttr = 'data-gallery-video-id';
        const $videoTarget = this.overlay.querySelector('[data-overlay-images]');
        let videoTemplate = '';
        let videoId = '';

        if (type === 'single') {
            $videos = $wrapper.querySelector('[' + videoIdAttr + ']');
            if ($videos) {
                if ($videos.getAttribute(videoIdAttr) === null) {
                    if ($videos.closest('[' + videoIdAttr + ']').getAttribute(videoIdAttr) != null) {
                        videoId = $videos.closest('[' + videoIdAttr + ']').getAttribute(videoIdAttr);
                    } else {
                        videoId = $videos.src;
                    }
                } else {
                    videoId = $videos.getAttribute(videoIdAttr);
                }
                const container = document.createElement('div');

                videoTemplate += '<span><a role="button" class="media__play is--white" data-youtube="' + videoId + '"<i>play</i></a><img width="720" height="405" src="//img.youtube.com/vi/' + videoId + '/maxresdefault.jpg" alt="Youtube Video Poster" /></span>';

                this.overlay.classList.add('is--single');
                container.classList.add('overlay-gallery__video');
                container.classList.add('media-wrapper');
                container.classList.add('swiper-slide');
                container.innerHTML = videoTemplate;

                $videoTarget.appendChild(container);
                const $media = this.overlay.querySelector('.media-wrapper');
                const $video = this.overlay.querySelector('[data-youtube]');

                import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                    new YoutubePlayer($video, { //eslint-disable-line
                        silent: false,
                        fullscreen: false,
                        controls: true,
                        loop: false,
                        id: videoId,
                        observe: false,
                        gallery: true,
                        onCall: () => {
                            $media.classList.add('is--shown');
                        },
                        onStart: () => {
                            $media.classList.add('is--shown');
                        },
                        onEnd: () => {
                        },
                        onPause: () => {
                            console.log('video pause');
                        }
                    });
                });
            }
        }

        if (type === 'slider' || type === 'multi') {
            $videos = [].slice.call($wrapper.querySelectorAll('img[data-gallery-image]'));

            $videos.forEach((video, index) => {
                const container = document.createElement('div');

                if (video.getAttribute(videoIdAttr) === null) {
                    if (video.closest('[' + videoIdAttr + ']').getAttribute(videoIdAttr) != null) {
                        videoId = video.closest('[' + videoIdAttr + ']').getAttribute(videoIdAttr);
                    } else {
                        videoId = video.src;
                    }
                } else {
                    videoId = video.getAttribute(videoIdAttr);
                }

                if (video.closest('.swiper-slide').classList.contains('swiper-slide-active')) {
                    this.activeIndex = index;
                }

                videoTemplate += '<img src="' + videoId + '" alt=""></div>';

                container.classList.add('location__gallery-image');
                container.classList.add('swiper-slide');
                container.innerHTML = videoTemplate;

                $videoTarget.appendChild(container);
            });
        }

        if (typeof callback === 'function') {
            callback();
        }
    }
}

export { OverlayGallery };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $overlayGallery = $context.querySelectorAll('[data-gallery]');

        if ($overlayGallery.length > 0) {
            $overlayGallery.forEach((gallery) => {
                const $overlay = new OverlayGallery(gallery);
                $overlay.initialize();
            });
        }
    }
});
